/**
 * Categorical chart palette in slot order, validated for color-blind separation on white.
 * The client reads the same colors from `--chart-1..8` in index.css; server-side renderers use these values.
 */
export const CHART_PALETTE = [
    '#00b585',
    '#1f86cc',
    '#cf6a3f',
    '#6e5bd0',
    '#7a9a1c',
    '#0aa0bf',
    '#d08c12',
    '#c8507a'
];
/** Grey for a series that should recede, such as "Other". The client reads it from `--chart-neutral`. */
export const CHART_NEUTRAL = '#c9c6bf';
/** How a chart config saves each palette color, as the color picker does. */
export const CHART_COLOR_TOKENS = [
    'hsl(var(--chart-1))',
    'hsl(var(--chart-2))',
    'hsl(var(--chart-3))',
    'hsl(var(--chart-4))',
    'hsl(var(--chart-5))',
    'hsl(var(--chart-6))',
    'hsl(var(--chart-7))',
    'hsl(var(--chart-8))'
];
export const CHART_NEUTRAL_TOKEN = 'hsl(var(--chart-neutral))';
// Literal colors the old palette saved into chart configs (color picker and AI builder), mapped to the
// nearest new hue so existing charts follow the palette.
const LEGACY_CHART_COLOR_SLOTS = {
    'hsl(173, 58%, 39%)': 0,
    'hsla(173, 58%, 39%, 0.6)': 0,
    'hsl(197, 37%, 24%)': 1,
    'hsla(197, 37%, 24%, 0.6)': 1,
    'hsl(27, 87%, 67%)': 2,
    'hsla(27, 87%, 67%, 0.6)': 2,
    'hsl(290, 65%, 58%)': 3,
    'hsl(43, 74%, 66%)': 6,
    'hsla(43, 74%, 66%, 0.6)': 6,
    'hsl(12, 76%, 61%)': 7,
    'hsla(12, 76%, 61%, 0.6)': 7
};
/** Zero-based palette slot for a saved series color, or undefined for a color outside the palette. */
const chartColorSlot = (color) => {
    const token = /^hsl\(var\(--chart-(\d+)\)\)$/.exec(color);
    if (token)
        return (Number(token[1]) - 1) % CHART_PALETTE.length;
    return LEGACY_CHART_COLOR_SLOTS[color];
};
/**
 * The palette slot a series draws in: its saved color's, or its place among the series when it has none. People can
 * only pick palette colors, so a color outside the palette came from AI and is drawn as if unset.
 */
export const seriesColorSlot = (savedColor, index) => {
    if (savedColor === CHART_NEUTRAL_TOKEN)
        return 'neutral';
    return (savedColor ? chartColorSlot(savedColor) : undefined) ?? index % CHART_PALETTE.length;
};
//# sourceMappingURL=chart-colors.js.map